<script setup lang="ts">
import DolphinRadioButton from '@/components/atoms/DolphinRadioButton.vue'

const model = defineModel<boolean>({ required: true })

const isDisplayDefaultOptions = [
  {
    type: true,
    label: '表示する',
    handler: () => {
      model.value = true
    },
  },
  {
    type: false,
    label: '表示しない',
    handler: () => {
      model.value = false
    },
  },
] as const
</script>

<template>
  <section>
    <p :class="$style.sectionTitle">メニューのデフォルト表示</p>
    <div :class="$style.sectionContent">
      <div :class="$style.optionsWrapper">
        <label
          v-for="isDisplayDefault of isDisplayDefaultOptions"
          :key="isDisplayDefault.label"
          :class="$style.option"
        >
          <DolphinRadioButton
            name="isDisplayDefault"
            :value="isDisplayDefault.type"
            :modelValue="model"
            @update:modelValue="isDisplayDefault.handler"
          />
          <span :class="$style.option__text">
            {{ isDisplayDefault.label }}
          </span>
        </label>
      </div>
    </div>
  </section>
</template>

<style module lang="scss">
.sectionTitle {
  font-size: 18px;
  font-weight: bold;
}

.sectionContent {
  margin-top: 16px;
}

.optionsWrapper {
  display: flex;
  gap: 24px;
}

.option {
  display: inline-flex;
  align-items: center;

  &__text {
    font-size: 14px;

    &:nth-child(n + 2) {
      margin-left: 4px;
    }
  }
}
</style>
